export default __webpack_public_path__ + "static/SmartLocationOfPublicFacilities-a2cf480b08396aadf2006353fdda57de.jpg";